// src/utils/clipboardUtils.js
import { toast } from 'react-toastify'; // Make sure react-toastify is installed

export const copyToClipboard = (text, successMessage = 'Copied to clipboard!') => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text)
      .then(() => {
        if (successMessage) {
          toast.success(successMessage);
        }
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
        toast.error('Failed to copy.');
      });
  } else {
    // Fallback for older browsers or insecure contexts (http)
    try {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge.
      textArea.style.opacity = 0; // Make it invisible
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      if (successMessage) {
        toast.success(successMessage);
      }
    } catch (err) {
      console.error('Fallback copy method failed: ', err);
      toast.error('Copying not supported or failed.');
    }
  }
};